import { render, staticRenderFns } from "./WhiteBoard.vue?vue&type=template&id=63b73c22&scoped=true"
import script from "./WhiteBoard.vue?vue&type=script&lang=js"
export * from "./WhiteBoard.vue?vue&type=script&lang=js"
import style0 from "./WhiteBoard.vue?vue&type=style&index=0&id=63b73c22&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b73c22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b73c22')) {
      api.createRecord('63b73c22', component.options)
    } else {
      api.reload('63b73c22', component.options)
    }
    module.hot.accept("./WhiteBoard.vue?vue&type=template&id=63b73c22&scoped=true", function () {
      api.rerender('63b73c22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WhiteBoard/WhiteBoard.vue"
export default component.exports